<script>
import AnonymousNavBar from '@components/v2/nav-bars/roles/AnonymousNavBar.vue'

export default {
  components: { AnonymousNavBar },
}
</script>

<template>
  <div :class="$style.container">
    <AnonymousNavBar :class="$style.colorNav" />
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.container {
  min-width: $size-site-thin-content-width-min;
  max-width: $size-site-thin-content-width-max;
  padding: 20px;
  margin: 60px auto 0 auto;
}

.colorNav {
  @extend %colorNav;
}
</style>
